<template>
  <div class="home-parent-header-main-container bg-main px-3 pb-3">
    <div class="d-flex flex-column flex-sm-row align-items-sm-center mb-2 mb-md-0">
      <div class="d-flex mb-2 mb-sm-0 pt-3 pt-sm-0 ">
        <p class="text-white mr-1 h5">
          Hi,
        </p>
        <p class="mr-4 text-white h5">
          {{ getUserName }}
        </p>
      </div>
    </div>
    <div class="mr-4 mr-sm-4">
      <p class="home-parent-progress-text text-right mr-4 mr-md-5 text-white small">
        {{ nearestBadge ? nearestBadge.name : '' }}
      </p>
      <div class="home-parent-progress-bar d-flex w-100 position-relative align-items-center ">
        <div class="home-parent-progress-bar-container w-100 overflow-hidden">
          <div
            class="home-parent-progress-bar-content"
            :style="`width:${progressBarWidth}%;`"
          ></div>
          <p class="home-parent-progress-bar-count m-0 p-0 position-absolute">
            {{ progressBarWidth }}%
          </p>
        </div>
        <div
          class="home-parent-progress-badge position-absolute bg-main d-flex align-items-center justify-content-center"
        >
          <i
            v-if="!nearestBadge || (nearestBadge && !nearestBadge.image)"
            class="material-icons cursor h1 m-0 p-0 text-warning"
          >
            local_police
          </i>
          <b-img
            v-if="nearestBadge && nearestBadge.image"
            fluid
            :src="nearestBadge.image"
            class="badge-image h-auto"
          ></b-img>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: {},
  computed: {
    ...mapGetters('user', [
      'getUserName',
      'userIsAParent',
      'getUserScore',
      'getUserScoreAll', // child element
      'getUserLevel', // child element
    ]),
    ...mapGetters('badges', ['getLockedBadges']),
    progressBarWidth() {
      const width =
        this.nearestBadge && this.nearestBadge.score
          ? (this.nearestBadge.score / this.nearestBadge.score_requirement) * 100
          : 0;
      return width.toFixed(2);
    },
  },
  data() {
    return {
      nearestBadge: null,
    };
  },
  mounted() {
    const badgesInProgress = JSON.parse(JSON.stringify(this.getLockedBadges.progressive_badges));

    this.nearestBadge = badgesInProgress.reduce((badgeMajorProgress, badge) => {
      const majorProgress = badgeMajorProgress.score_requirement - badgeMajorProgress.score;
      const badgeProgress = badge.score_requirement - badge.score;

      return badgeProgress > majorProgress ? badge : badgeMajorProgress;
    });
  },
};
</script>
<style scoped lang="scss">
.home-parent-header-main-container {
  .badge-image {
    width: auto;
    height: 60px !important;
    object-fit: cover;
    border-radius: 50%;
    border: 1px solid #fff;
  }
  .home-header-points-container {
    height: 46.4px;
    border-radius: calc(46.4px / 2);
    padding: 0 27px;
    background: transparent linear-gradient(271deg, #ffda9f 0%, #e2fffe 100%) 0% 0% no-repeat
      padding-box;
    letter-spacing: 0;
    color: #707070;
    opacity: 1;
  }
  .home-parent-progress-bar {
    height: 60px;
    margin-top: -20px;
    .home-parent-progress-bar-container {
      height: 25px;
      border-radius: calc(25px / 2);
      background-color: #ffffff;
      .home-parent-progress-bar-content {
        border-radius: calc(25px / 2);
        height: 100%;
        background: transparent linear-gradient(270deg, #ffbc05 0%, #e2fffe 100%) 0% 0% no-repeat
          padding-box;
      }
      .home-parent-progress-bar-count {
        display: none;
        letter-spacing: 0;
        color: #707070;
      }
    }
    .home-parent-progress-bar-container:hover {
      display: flex;
      .home-parent-progress-bar-count {
        width: 100%;
        display: flex;
        align-self: center;
        justify-self: center;
        justify-content: center;
      }
    }
    .home-parent-progress-text {
      font-size: 16px;
      font-weight: 300;
    }
    .home-parent-progress-badge {
      width: 60px;
      height: 60px;
      border-radius: calc(60px / 2);
      box-shadow: 0px 3px 6px #00000070;
      align-self: center;
      right: calc(-60px / 2);
    }
  }
}
</style>
